import { render, staticRenderFns } from "./WebpartTemplate.vue?vue&type=template&id=e477f26c"
import script from "./WebpartTemplate.vue?vue&type=script&lang=ts"
export * from "./WebpartTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports